import * as Init from '../init.js';
import { CLAPI } from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as MDRES from './market.dres.js'
import * as MDATA from './market.data.js'
import * as COMMON from './common.res.js'

function getHeadInfo(inData)
{
    if (inData.modulename === 'trend1') {
        return '强度列表'
    }
    else if (inData.modulename === 'trend2') {
        return '能量列表'
    }
    else if (inData.modulename === 'zxcode') {
        return '自选列表'
    }
    else if (inData.modulename === 'dxcode') {
        return '短线关注'
    }
    else if (inData.modulename === 'cxcode') {
        return '长线关注'
    }
    else if (inData.modulename === 'adjust') {
        return '持仓列表'
    }
    return '行情日期'
}
function setDateCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 0,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: COMMON.CHART_LEFT_DATES,
        rectMain: curRect

    }
    
    COMMON.initDateCtrl(getHeadInfo(inData))

    for (let index = 0; index < inData['dates'].datas.length; index++) {
        // COMMON.incrDateCtrl(index, CLAPI.getData(inData['dates'], 'date', index), 0.0)
        COMMON.incrDateCtrl(index, CLAPI.getData(inData['dates'], 'date', index))
    }
    console.log(curCfg.config);
    
    curCfg.config.selectIndex = Init.getUserInfo(inData.modulename, 'dateindex', 0)
    // console.log(leftLayoutCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            let newIndex = result.selectIndex
            Init.setUserInfo(inData.modulename, 'dateindex', newIndex)
            onLoadData(inData, false)
        }
    })
}

function setMarket(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    let tableInfo = MDRES.easyMarketHead

    if (CLAPI.Utils.strIncludes(inData.modulename, ['trend1','trend2'])) {
        if (inData.modulename === 'trend1') {
            tableInfo = MDRES.TrendHead1  
        }
        else {
            tableInfo = MDRES.TrendHead2 
        }
    }
    else if (CLAPI.Utils.strIncludes(inData.modulename, ['zxcode','dxcode', 'cxcode'])) {
        tableInfo = MDRES.selectMarketHead  
    }
    else if (CLAPI.Utils.strIncludes(inData.modulename, ['adjust'])) {
        tableInfo = MDRES.adjustMarketHead  
    }
    
    const mainLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 5
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep(
            {
                fieldlock  : 4,  // 按左键时，前面3个字段不动        
                curKeyIdx : 1,   // 用于检索curKey的字段索引
            }, CLAPI.ChartRes.CHART_TABLE),
        tableInfo : tableInfo,
        rectMain: CLAPI.getChartRect(region, 1, 1, 0, 0)
    }
    const mainchart = chart.createChart('user.main', 'system.table', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'headclick') {
            console.log(result);
        }
        if (result.event === 'changeselect') {
            Init.setcurKey(result.curCode)
            chart.setlinkInfo('curKey', result.curCode)
        }
        if (result.event === 'dataclick') {
            // console.log(result, makets);
            result.key = 'Enter'
            result.code = 'Enter'
            result.keyCode = 13

            console.log('MARKET', result, Init.getcurKey())

            Init.setcurKey(result.curCode)
            chart.setlinkInfo('curKey', result.curCode)
            Init.sendKeydownEvent(result)
        }
    })
    chart.setlinkInfo('curKey', Init.getcurKey())
    chart.bindData(mainchart, chartName)

}

function readyMarket(curChart, inData) {
    const chartName = inData.modulename
    const chart = curChart.getChart(inData.modulename)

    // 读行情时 统一更新chart缓存的代码信息
    inData['KeyInfo'] = DATAS.mAinfoToKeyInfo(inData['ainfo'])
    chart.setKeyInfo(inData['KeyInfo'])
    // console.log(keyInfo);

    inData.newInfo = MDATA.ExtractNewInfo(inData['astop'], inData.newInfo)
    
    let markets = {}
    if (CLAPI.Utils.strIncludes(inData.modulename, ['normal','market'])) {
        markets = MDATA.AinfoToMarket(inData['ainfo'], inData['KeyInfo'], inData.newInfo)  
    }
    else if (CLAPI.Utils.strIncludes(inData.modulename, ['trend1','trend2'])) {
        if (inData.modulename === 'trend1') {
            markets = MDATA.AinfoToTrend1(inData['other'], inData['KeyInfo'], inData.newInfo, inData['other'])  
        }
        else {
            markets = MDATA.AinfoToTrend2(inData['other'], inData['KeyInfo'], inData.newInfo, inData['other'])  
        }
    }
    else if (CLAPI.Utils.strIncludes(inData.modulename, ['zxcode','dxcode', 'cxcode'])) {
        markets = MDATA.AinfoToCharList(inData['ainfo'], inData['KeyInfo'], inData.newInfo, inData['other'])  
    }
    else if (CLAPI.Utils.strIncludes(inData.modulename, ['adjust'])) {
        markets = MDATA.AinfoToAdjust(inData['ainfo'], inData['KeyInfo'], inData.newInfo, inData['other'])  
    }
    else {
        markets = MDATA.AinfoToMarket(inData['ainfo'], inData['KeyInfo'], inData.newInfo)       
    }
    chart.setData(chartName, markets)

}

// 画列表
function drawMarket(inData, isFirst) {

    console.log('Draw ====> Market Table')
    console.log(inData)
    const curChart = Init.getSysChart()
    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        const chart = curChart.initChart([inData.modulename, 'DateCtrl'])
        // 得到第一个窗口
        const canvas = Init.canvas
        
        // const left = 130 * Init.scale
        const left = 90 * Init.scale
        // 设置左部窗口
        setDateCtrl(curChart, 'DateCtrl', inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: left - Init.scale,
            height: canvas.height,
        })

        setMarket(curChart, inData.modulename, inData, {
            style: 'average',
            top: 0,
            left: left,
            width: canvas.width - left,
            height: canvas.height,
        })
    }

    readyMarket(curChart, inData)

    curChart.onPaint()
}

function onLoadData (inData, isFirst) {
    let curIndex = Init.getUserInfo(inData.modulename, 'dateindex', 0)
    curIndex = curIndex
    
    if (inData['dates'].datas[curIndex] === undefined) {
        return
    }
    const curDate = CLAPI.getData(inData['dates'], 'date', curIndex)
    const cmds = {
        "ainfo"  : { "cmd" : "get", "subject" : "CN000000.alpha_info", "service": "atdb/minu1", "info" : { "sub-date" : curDate}},
        "astop"  : { "cmd" : "get", "subject" : "CN000000.alpha_stopinfo", "service": "atdb/minu1", "info" : { "sub-date" : curDate}},
    }
    if (CLAPI.Utils.strIncludes(inData.modulename, ['trend1','trend2'])) {
        cmds["other"] = { 
                "cmd" : "get", 
                "subject" : "db_params", 
                "service": inData.modulepath + '/db_params/',
                "info" : {"sub-date" : curDate, "fields" : MDATA.ask_trend_field }
            }       
    }
    if (CLAPI.Utils.strIncludes(inData.modulename, ['zxcode','dxcode', 'cxcode'])) {
        cmds["other"] = { 
                "cmd" : 'rfile', 
                "subject" : inData.modulename + '.csv', 
                "service": inData.modulepath,
            }       
    }
    if (CLAPI.Utils.strIncludes(inData.modulename, ['adjust'])) {
        cmds["other"] = { 
                "cmd": "get",
                "subject": "assets",
                "service": inData.modulepath + "/assets/",
                "info": {
                    "sub-date": curDate
                }
            }       
    }
    Init.sendCommand( { cmds : cmds }, 
        
        function reply(datas) {
            console.log(datas);
            if (Init.checkDatas(datas)) {
                inData['ainfo'] = datas['ainfo']
                inData['astop'] = datas['astop']
                inData['other'] = datas['other']
                drawMarket(inData, isFirst)
            }
    });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'normal'
    inData.modulepath = argvs.modulepath ?? inData.modulename
    Init.sendCommand(
        {   
            cmds : {
                "dates"   : { "cmd" : "get", "subject" : "SH000001.alpha_info", "service": "merge/ainfo", "info" : {"offset" : -60, "fields" : 'msec'}}
            }
        },
        function reply(datas) {
            // console.log(datas)
            if (Init.checkDatas(datas)) {
                inData['dates'] = DATAS.swapDatefromMsec(datas['dates'], 'msec')
                onLoadData(inData, true)
            }
        });
}


// 注册方法到参数表
